var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"m-1 m-sm-4"},_vm._l((_vm.items),function(item){return _c('feature-list-item',{key:`feature-item${item.id}`,staticClass:"col-md-6 col-lg-4 col-xl-3 col-12",attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }